import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { boolean } from 'yup';

interface IPaymentDashSlice {
  showColumnSettings:boolean;
}

const initialState: IPaymentDashSlice = {
  showColumnSettings:false
};

export const paymentDashboardSlice = createSlice({
  name: 'themeSettings',
  initialState,
  reducers: {
    toggleColumnSettingsPayDash:(state,action)=>{
        state.showColumnSettings = action.payload
    }
  },
});

export const { toggleColumnSettingsPayDash} = paymentDashboardSlice.actions;

export default paymentDashboardSlice.reducer;
